export const question = [
  {
    id: 1,
    question: "Eligibility",
    answer: [
      {
        item: "Businesses with a valid vending certificate or ID issued by Town Councils/Municipalities",
      },
      {
        item: "Businesses with a recommendation letter from Town Councils, Municipalities, or other competent government authorities",
      },
      {
        item: "Must be 18 years or older",
      },
    ],
  },
  {
    id: 2,
    question: "Purpose",
    answer: [
      {
        item: "To provide immediate credit support for restarting or upscaling businesses that have slowed or halted.",
      },
    ],
  },
  {
    id: 3,
    question: "Benefits",
    answer: [
      {
        item: "No margin requirement",
      },
      {
        item: "Affordable processing fee (ZMW 200 flat)",
      },
      {
        item: "No prepayment charges",
      },
      {
        item: "Covered under the Zambia Credit Guarantee Scheme (up to 80% of portfolio loss)",
      },
      {
        item: "Opportunity for refinancing with enhanced limits for timely repayment",
      },
    ],
  },
  {
    id: 4,
    question: "Security",
    answer: [
      {
        item: "Debenture on stock created out of bank funds",
      },
      {
        item: "No collateral required",
      },
      {
        item: "Third-party guarantee/recommendation preferable",
      },
    ],
  },
  {
    id: 5,
    question: "Repayment Period",
    answer: [
      {
        item: "12 monthly installments beginning one month after disbursement",
      },
      {
        item: "Early repayment allows access to higher refinancing limits",
      },
    ],
  },
];
